import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

type MarkdownProps = {
  children: string;
};

export const Markdown: React.FC<MarkdownProps> = ({ children }) => {
  return (
    <ReactMarkdown
      rehypePlugins={[rehypeRaw]}
      components={{
        h1: (props) => (
          <h1
            className="text-gray-800 text-3xl font-semibold mt-8 mb-4"
            {...props}
          />
        ),
        h2: (props) => (
          <h2
            className="text-gray-800 text-2xl font-medium mt-6 mb-3"
            {...props}
          />
        ),
        h3: (props) => (
          <span className="text-gray-800 font-medium mt-2" {...props} />
        ),
        p: (props) => (
          <div className="text-gray-800 text-md leading-relaxed" {...props} />
        ),
        ul: (props) => (
          <ul
            className="text-gray-800 list-disc list-inside space-y-2"
            {...props}
          />
        ),
        li: (props) => <li className="text-gray-800 ml-4" {...props} />,
        a: (props) => <a className="text-blue-600 underline" {...props} />,
      }}
    >
      {children}
    </ReactMarkdown>
  );
};
